import { type HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export type DialogBodyProps = HTMLAttributes<HTMLDivElement>;

export default function DialogBody({
  className = '',
  ...props
}: DialogBodyProps) {
  return <div className={twMerge(classes.dialogBody, className)} {...props} />;
}
